import { useState } from 'react';
import { useForm } from 'react-hook-form';
import type { CreateVisitType } from '../../visits/entity';
import { useCustomerAuth } from '@features/customer-reservations/CustomerAuthContext';
import {
  useReservationServicesQuery,
  useMyVisitsQuery,
} from '@features/customer-reservations/queries';

export type PreviewVisit = {
  startTime: string;
  endTime: string;
  serviceName?: string;
};

export const useBookingPage = () => {
  const { isAuthenticated, loading, logout } = useCustomerAuth();

  const {
    data: servicesData,
    isLoading: isLoadingServices,
    error: allowedServicesError,
  } = useReservationServicesQuery(isAuthenticated);

  const { data: myVisitsData, isLoading: isLoadingMyVisits } = useMyVisitsQuery(isAuthenticated);

  const [previewVisit, setPreviewVisit] = useState<PreviewVisit | undefined>();

  const methods = useForm<CreateVisitType>({
    defaultValues: { depositRequired: false },
  });

  return {
    loading,
    logout,
    servicesData,
    isLoadingServices,
    isLoadingMyVisits,
    allowedServicesError,
    myVisitsData,
    previewVisit,
    setPreviewVisit,
    methods,
  };
};
